import { Field, ErrorMessage } from 'formik';
import { Tooltip } from 'react-tooltip'; // Ensure your tooltip library is installed and configured

const PaymentPreferenceSection = () => {
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
      <p className="mb-2 text-lg font-medium text-blue-800">
        Choose Your Payment Preference<span className="text-red-500">*</span>
      </p>
      <p className="mb-3 text-sm text-blue-700">
        We offer flexible payment options to make booking with us simple and
        stress-free. You can secure your appointment with a 30% deposit, pay in
        full now and get 15% off, or split your total into 4 easy payments using
        Afterpay. No matter which you choose, your ride is in great hands.
      </p>
      <div className="flex flex-col gap-4">
        <label className="flex items-center">
          <Field
            type="radio"
            name="paymentOption"
            value="Deposit"
            className="mr-2"
          />
          <span className="text-sm text-blue-800">
            30% Deposit
            <span
              className="ml-2 cursor-pointer"
              data-tooltip-id="deposit-tooltip"
              aria-label="30% Deposit Info"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline h-5 w-5 text-blue-800"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 0a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V5h2v6z" />
              </svg>
            </span>
            <Tooltip id="deposit-tooltip" place="top" effect="solid">
              A 30% deposit is the minimum payment required to secure your
              appointment.
            </Tooltip>
          </span>
        </label>
        <label className="flex items-center">
          <Field
            type="radio"
            name="paymentOption"
            value="Full"
            className="mr-2"
          />
          <span className="text-sm text-blue-800">
            Pay in Full
            <span
              className="ml-2 cursor-pointer"
              data-tooltip-id="full-tooltip"
              aria-label="Pay in Full Info"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline h-5 w-5 text-blue-800"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 0a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V5h2v6z" />
              </svg>
            </span>
            <Tooltip id="full-tooltip" place="top" effect="solid">
              Pay the full amount upfront and receive a 15% discount on your
              total.
            </Tooltip>
          </span>
        </label>
        <label className="flex items-center">
          <Field
            type="radio"
            name="paymentOption"
            value="Afterpay"
            className="mr-2"
          />
          <span className="text-sm text-blue-800">
            Pay with Afterpay
            <span
              className="ml-2 cursor-pointer"
              data-tooltip-id="afterpay-tooltip"
              aria-label="Afterpay Info"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="inline h-5 w-5 text-blue-800"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 0a10 10 0 100 20 10 10 0 000-20zm1 15h-2v-2h2v2zm0-4h-2V5h2v6z" />
              </svg>
            </span>
            <Tooltip id="afterpay-tooltip" place="top" effect="solid">
              Split your total into 4 easy payments with Afterpay.
            </Tooltip>
          </span>
        </label>
      </div>
      <ErrorMessage
        name="paymentOption"
        component="div"
        className="mt-1 text-xs text-red-500"
      />
    </div>
  );
};

export default PaymentPreferenceSection;
